module.exports = __webpack_public_path__ + "static/media/08-icon.e533aeea.svg";